import { PropertyDetailsContext } from "@/contexts"
import { useContext } from "react"

export const usePropertyDetailContext = () => {
  const context = useContext(PropertyDetailsContext)

  if (!context) throw new Error('usePropertyDetailsContext have to be wrapped by PropertyDetailsContextProvider')

  return context
}